import { css } from "@emotion/react";
import { Link } from "react-router-dom";
import { FaPlus, FaQuestionCircle } from "react-icons/fa";
import { DateTime } from "luxon";
import { DownloadsLabel } from "../shared/DownloadsLabel";
import {
    AllTimeDownloadsHelp,
    AverageDownloadsPerEpisodeHelp,
    KeyMetricsHelp,
    LatestEpisodeHelp,
    ThirtyDayAudienceHelp,
    ThirtyDayDownloadsHelp
} from "../shared/MetricsHelp";
import styles from "./ShowsTableView.module.scss";
import defaultIcon from "../../assets/default-icon.png";
import { useAccountID } from "../store/account";
import { useShow } from "../store/show";
import SparkineChart from "../shared/SparlkineChart";
import { Loading } from "@podtrac/common/components/Loading";
import { forwardRef } from "react";

const numberFormat = new Intl.NumberFormat().format;
const percentFormat = new Intl.NumberFormat(undefined, { style: "percent", signDisplay: "always" })
    .format;

export const ShowRow = forwardRef(function ShowRow({ showSummary, style, openModal, index }, ref) {

    // measureElement ref is causing some wierd layout issues; turn off for now

    return (
        <tr /*ref={ref}*/ data-index={index} style={style}>
            <td style={{ width: "40%" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    {showSummary ? (
                        <>
                            <Link to={`shows/${ showSummary.showID }`}>
                                <img
                                    src={showSummary.showImageUrl || defaultIcon}
                                    className={styles.icon}
                                    onError={event => (event.target.src = defaultIcon)}
                                />
                            </Link>
                            <h3>
                                <Link to={`shows/${ showSummary.showID }`}>{showSummary.showName}</Link>
                            </h3>
                        </>) : (<>
                            <img
                                src={defaultIcon}
                                className={styles.icon}
                                style={{ filter: "grayscale(100%) opacity(50%)" }}
                            />
                            <h3>…</h3>
                        </>)}
                </div>
            </td>
            <td style={{ width: "15%", textAlign: "right" }}>
                {showSummary ? (
                    <div className={styles.number}>
                        {showSummary.allTimeDownloads !== undefined
                            ? numberFormat(showSummary.allTimeDownloads)
                            : "\u00A0"}
                    </div>) : null}
            </td>
            {showSummary ? <ExtraColumns showID={showSummary.showID} /> : <BlankColumns />}
            {/*<div className={styles.topgrid}>
                {showSummary ? (
                    <>
                        <Link to={`shows/${showSummary.showID}`}>
                            <img
                                src={showSummary.showImageUrl || defaultIcon}
                                className={styles.icon}
                                onError={event => (event.target.src = defaultIcon)}
                            />
                        </Link>
                        <h3>
                            <Link to={`shows/${showSummary.showID}`}>{showSummary.showName}</Link>
                        </h3>
                        <div className={styles.downloads}>
                            <div className={styles.label}>
                                All-Time <DownloadsLabel showID={showSummary.showID} />{" "}
                                <FaQuestionCircle
                                    onClick={() =>
                                        openModal(
                                            "Downloads",
                                            "All-Time",
                                            0,
                                            0,
                                            null,
                                            null,
                                            AllTimeDownloadsHelp,
                                            showSummary
                                        )
                                    }
                                />
                            </div>
                            <div className={styles.number}>
                                {showSummary.allTimeDownloads !== undefined
                                    ? numberFormat(showSummary.allTimeDownloads)
                                    : "\u00A0"}
                            </div>
                        </div>
                        <Link className={styles.more} to={`shows/${showSummary.showID}`}>
                            More ▶
                        </Link>
                    </>
                ) : (
                    <>
                        <img
                            src={defaultIcon}
                            className={styles.icon}
                            style={{ filter: "grayscale(100%) opacity(50%)" }}
                        />
                        <h3>…</h3>
                        <div></div>
                        <div></div>
                    </>
                )}
            </div> */}
            {/*show ? (
                <>
                    <div className={styles.midgrid}>
                        <ChartedMetric
                            range="Average 7-Day"
                            name={downloadsLabel + "/Episode"}
                            value={show.averageSevenDayGlobalDownloads}
                            prevValue={show.averageSevenDayGlobalDownloadsPrevious}
                            index={"averageSevenDayGlobalDownloads"}
                            prevIndex={"averageSevenDayGlobalDownloadsPrevious"}
                            dateIndex={"measurementDate"}
                            data={show.sparklines}
                            openModal={openModal}
                            help={AverageDownloadsPerEpisodeHelp}
                            show={show}
                        />
                        <ChartedMetric
                            range="30-Day"
                            name={downloadsLabel}
                            value={show.globalDownloads30Day}
                            prevValue={show.globalDownloads30DayPrevious}
                            index={"globalDownloads30Day"}
                            prevIndex={"globalDownloads30DayPrevious"}
                            dateIndex={"measurementDate"}
                            data={show.sparklines}
                            openModal={openModal}
                            help={ThirtyDayDownloadsHelp}
                            show={show}
                        />
                        <ChartedMetric
                            range="30-Day"
                            name="Audience"
                            value={show.globalAudience30Day}
                            prevValue={show.globalAudience30DayPrevious}
                            index={"globalAudience30Day"}
                            prevIndex={"globalAudience30DayPrevious"}
                            dateIndex={"measurementDate"}
                            data={show.sparklines}
                            openModal={openModal}
                            help={ThirtyDayAudienceHelp}
                            show={show}
                        />
                    </div>
                    <LatestEpisode show={show} openModal={openModal} />
                </>
            ) : isError ? (
                <p style={{ margin: "2em" }}>
                    Error loading show data{" "}
                    <button type="button" onClick={refetch}>
                        retry
                    </button>
                </p>
            ) : (
                <Loading />
            )*/}
        </tr>
    );
});

function BlankColumns() {
    return <>
        <td />
        <td />
        <td />
    </>;
}

function ExtraColumns({ showID }) {
    const accountID = useAccountID();

    const query = useShow(accountID, showID),
        { isPlaceholderData, isLoading, isError, data: show, refetch } = query;

    return show ? <>
        <td style={{ width: "15%", textAlign: "right" }}>
            <div className={styles.number}>
                {show.globalDownloads30Day !== undefined
                    ? numberFormat(show.globalDownloads30Day)
                    : "\u00A0"}
                <GrowthSpan value={show.globalDownloads30Day} prevValue={show.globalDownloads30DayPrevious}>month/month</GrowthSpan>
            </div>
        </td>
        <td style={{ width: "15%", textAlign: "right" }}>
            <div className={styles.number}>
                {show.globalAudience30Day !== undefined
                    ? numberFormat(show.globalAudience30Day)
                    : "\u00A0"}
                <GrowthSpan value={show.globalAudience30Day} prevValue={show.globalAudience30DayPrevious}>month/month</GrowthSpan>
            </div>
        </td>
        <td style={{ width: "15%", textAlign: "right" }}>
            <div className={styles.number}>
                {show.currentEpisodeGlobalDownloads !== undefined
                    ? numberFormat(show.currentEpisodeGlobalDownloads)
                    : "\u00A0"}
                <GrowthSpan value={show.currentEpisodeGlobalDownloads} prevValue={show.previousEpisodeGlobalDownloadsOverTimePeriod}>vs. previous</GrowthSpan>
            </div>
        </td>
    </> : <BlankColumns />;
}


function ChartedMetric({
    name,
    range,
    value,
    prevValue,
    data,
    dateIndex,
    index,
    prevIndex,
    help,
    openModal,
    show
}) {
    return (
        <div
            onClick={() => openModal(name, range, value, prevValue, index, prevIndex, help, show)}
            css={css`
                display: grid;
                justify-items: center;
                cursor: pointer;
                padding: 0.25rem;
                border-left: 0.0625rem solid transparent;
                border-right: 0.0625rem solid transparent;
                transition: all 0.1s;
                &:hover {
                    box-shadow: 0 0 0.125rem #eee;
                }
            `}
        >
            <div
                css={css`
                    font-size: 0.65rem;
                    line-height: 1rem;
                    text-transform: uppercase;
                    font-weight: 400;
                `}
            >
                {range}
            </div>
            <div
                css={css`
                    line-height: 1.5rem;
                    font-size: 1.25rem;
                    font-weight: 700;
                `}
            >
                {name}{" "}
                <FaQuestionCircle
                    css={css`
                        cursor: pointer;
                        opacity: 0.7;
                        transition: opacity 0.1s;
                        font-size: 0.65rem;
                        vertical-align: text-top;
                        &:hover {
                            opacity: 1;
                        }
                    `}
                />
            </div>
            <div
                css={css`
                    font-size: 2rem;
                    line-height: 3rem;
                `}
            >
                {value !== undefined ? numberFormat(value) : "\u00A0"}
            </div>
            <SparkineChart data={data} index={index} dateIndex={dateIndex} />
            <div
                css={css`
                    font-size: 1rem;
                    line-height: 1.5rem;
                `}
            >
                <GrowthSpan value={value} prevValue={prevValue}>
                    month/month
                </GrowthSpan>
            </div>
        </div>
    );
}

function LatestEpisode({ show: s, openModal }) {
    return (
        <div
            css={css`
                display: grid;
                grid-template-columns: 1fr 20ch 10ch;
                margin-top: 0.5rem;
                padding-top: 0.1875rem;
                border-top: 0.0625rem solid #eee;
                align-items: center;
            `}
        >
            <div
                css={css`
                    font-size: 0.65rem;
                    line-height: 1rem;
                    text-transform: uppercase;
                    font-weight: 400;
                `}
            >
                Latest Episode
            </div>
            <div
                css={css`
                    font-size: 0.65rem;
                    line-height: 1rem;
                    text-transform: uppercase;
                    font-weight: 400;
                    justify-self: center;
                `}
            >
                <DownloadsLabel showID={s.showID} /> To-Date{" "}
                <FaQuestionCircle
                    css={css`
                        cursor: pointer;
                        opacity: 0.7;
                        transition: opacity 0.1s;
                        vertical-align: text-top;
                        &:hover {
                            opacity: 1;
                        }
                    `}
                    onClick={() =>
                        openModal(
                            "Downloads-To-Date",
                            "Latest Episode",
                            0,
                            0,
                            null,
                            null,
                            LatestEpisodeHelp,
                            s
                        )
                    }
                />
            </div>
            <div
                css={css`
                    font-size: 0.65rem;
                    line-height: 1rem;
                    text-transform: uppercase;
                    font-weight: 400;
                    justify-self: center;
                `}
            >
                vs. Previous
            </div>
            <div
                css={css`
                    font-size: 1.25rem;
                    line-height: 1.5rem;
                    align-self: center;
                    font-weight: 500;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                `}
            >
                {s.currentEpisodeTitle}
                <div
                    css={css`
                        font-size: 0.65rem;
                        line-height: 1rem;
                        text-transform: uppercase;
                        font-weight: 400;
                        opacity: 0.5;
                    `}
                >
                    Published:{" "}
                    {s.currentEpisodePubDate &&
                        DateTime.fromISO(s.currentEpisodePubDate, { zone: "utc" }).toLocaleString(
                            DateTime.DATE_FULL
                        )}
                </div>
            </div>
            <div
                css={css`
                    font-size: 1.75rem;
                    line-height: 2.5rem;
                    justify-self: center;
                `}
            >
                {s.currentEpisodeGlobalDownloads !== undefined
                    ? numberFormat(s.currentEpisodeGlobalDownloads)
                    : "\u00A0"}
            </div>
            <div
                css={css`
                    font-size: 1.25rem;
                    line-height: 2.5rem;
                    justify-self: center;
                    align-self: center;
                `}
            >
                <GrowthSpan
                    value={s.currentEpisodeGlobalDownloads}
                    prevValue={s.previousEpisodeGlobalDownloadsOverTimePeriod}
                />
            </div>
        </div>
    );
}

const epsilon = 0.01;

function GrowthSpan({ value, prevValue, children }) {
    if (!prevValue) return "\u00A0";

    let growth = (value - prevValue) / prevValue;
    if (Math.abs(growth) < epsilon) growth = 0;

    const msg = percentFormat(growth);

    return (
        <span
            css={css`
                color: ${growth > 0 ? "#0a0" : "#888"};
                font-weight: 500;
            `}
        >
            {msg} {children}
        </span>
    );
}
